import { IApplicationState } from '@Site/rootReducer'

import {
  ITheme,
} from './types'

export const getThemes = (state: IApplicationState): ITheme[] => state.themes.themes
export const getThemesHasLoadedInitially = (state: IApplicationState): boolean => state.themes.hasLoadedInitially
